import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComboInputComponent } from './combo-input.component';
import { FormsModule } from "@angular/forms";
@NgModule({
    imports: [CommonModule,
        FormsModule
],
    declarations: [ComboInputComponent],
    exports: [ComboInputComponent],
    providers: []
})
export class ComboInputModule { }


// WEBPACK FOOTER //
// ./src/angular_library/components/combo-input/combo-input.module.ts